module.exports = __webpack_public_path__ + "assets/img/certificate_stats_icon.svg";